export const EMAIL_REG_EXP = new RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
export const PASSWORD_REG_EXP = new RegExp(/^[a-zA-Z0-9.!#@$%&’*+/=?^_`{|}~-]{8,20}$/);
